import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-friendly-captcha',
  template: `<div #captcha></div>`
})
export class FriendlyCaptchaComponent implements AfterViewInit {

  @ViewChild('captcha', { static: true }) captcha!: ElementRef;
  @Output() solved = new EventEmitter<string>();

  async ngAfterViewInit() {
    await this.loadScript();
    this.renderCaptcha();
  }

  private loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).FriendlyCaptcha) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.friendlycaptcha.com/widget/v2/friendlycaptcha.min.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject('Failed to load FriendlyCaptcha');
      document.body.appendChild(script);
    });
  }

  private renderCaptcha() {
    const el = document.createElement('friendly-captcha');
    el.setAttribute('sitekey', 'YOUR_SITE_KEY');

    el.addEventListener('frc:done', (event: any) => {
      this.solved.emit(event.detail.response);
    });

    this.captcha.nativeElement.appendChild(el);
  }
}
